/*****************************************************************************
 * PROJECT NAME   : SEC 회의실관리 프로젝트
 * SUBSYSTEM NAME : Admin
 * FILE NAME      : Error500.vue
 * DESCRIPTION    : 500 에러 페이지
 *
 * VERSION NO     author           date        content  -> info
 * ----------------------------------------------------------------------------
 *    1.0       K.Hur      2021-09-27      init
 *****************************************************************************/

<template>
  <div class="checkin" id="container">
    <h1>500 에러 페이지</h1>
  </div>
</template>
